import { md5 } from 'components/display/lib/md5'

export function FirestoreWriteUserToDb(app) {
  let payload = {
    fields: {
      age: { integerValue: app.user.age },
      predictedAge: { integerValue: app.user.predictedAge },
      topTracks: { stringValue: app.user.topTracks.join(',') },
      featureProfile: {
        mapValue: {
          fields: {}
        }
      }
    }
  }
  let persId = md5(app.user.age + '-' + app.user.topTracks.join(''))
  for (let i = 0, len = app.audioFeatures.length; i < len; i++) {
    payload.fields.featureProfile.mapValue.fields[app.audioFeatures[i]] = {
      doubleValue: app.user.featureProfile[app.audioFeatures[i]]
    }
  }

  return fetch(
    'https://firestore.googleapis.com/v1/projects/tamedia-spotify/databases/(default)/documents/users?documentId=' +
      persId,
    {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'post',
      body: JSON.stringify(payload)
    }
  )
    .then(response => response.json())
    .then(data => {
      if (data.error && data.error.code === 409) {
        app.alreadyPresent = true
        console.log('User already present, continue.')
      } else if (data.error) {
        throw data.error
      } else {
        console.log('Successfully saved user.')
      }

      return Promise.resolve(app)
    })
    .catch(error => {
      console.log('Failed to save user.')
      console.log(error)
      throw error
    })
}

function getRunningAverageFromDb(app) {
  return fetch(
    'https://firestore.googleapis.com/v1/projects/tamedia-spotify/databases/(default)/documents/app/running',
    {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'get'
    }
  )
    .then(response => response.json())
    .then(data => {
      // Error code 404 is returned, if the "running" document does not exist
      // This is only the case if the firestore db is reset
      if (data.error && data.error.code === 404) {
        console.log('Running document does not exist, filling with zeroes')

        app.runningCount = 0
        app.runningAge = 0
        app.runningAverage = {}
        for (let i = 0, len = app.audioFeatures.length; i < len; i++) {
          app.runningAverage[app.audioFeatures[i]] = 0
        }
      } else if (data.error) {
        throw data.error
      } else {
        console.log('Successfully got running average')

        app.runningCount = parseInt(data.fields.count.integerValue)
        app.runningAge = data.fields.age.doubleValue
        app.runningAverage = {}
        for (let i = 0, len = app.audioFeatures.length; i < len; i++) {
          app.runningAverage[app.audioFeatures[i]] =
            data.fields[app.audioFeatures[i]].doubleValue
        }
      }

      return Promise.resolve(app)
    })
    .catch(error => {
      console.log('Failed to get running average.')
      console.log(error)
      throw error
    })
}

function calcRunningAverage(app) {
  app.runningCount += 1

  app.runningAge =
    (app.runningAge * (app.runningCount - 1) + app.user.age) / app.runningCount

  for (let i = 0, len = app.audioFeatures.length; i < len; i++) {
    app.runningAverage[app.audioFeatures[i]] =
      (app.runningAverage[app.audioFeatures[i]] * (app.runningCount - 1) +
        app.user.featureProfile[app.audioFeatures[i]]) /
      app.runningCount
  }

  return Promise.resolve(app)
}

function writeRunningAverageToDb(app) {
  let payload = {
    name: 'running',
    fields: {
      count: { integerValue: app.runningCount },
      age: { doubleValue: app.runningAge }
    }
  }
  for (let i = 0, len = app.audioFeatures.length; i < len; i++) {
    payload.fields[app.audioFeatures[i]] = {
      doubleValue: app.runningAverage[app.audioFeatures[i]]
    }
  }

  return fetch(
    'https://firestore.googleapis.com/v1/projects/tamedia-spotify/databases/(default)/documents/app/running',
    {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'patch',
      body: JSON.stringify(payload)
    }
  )
    .then(response => response.json())
    .then(data => {
      if (data.error) {
        throw data.error
      }
      console.log('Successfully saved running average.')
      console.log(data)

      return Promise.resolve(app)
    })
    .catch(error => {
      console.log('Failed to save running average.')
      console.log(error)
      throw error
    })
}

export function FirestoreHandleRunningAverage(app) {
  if (app.alreadyPresent) {
    return getRunningAverageFromDb(app)
  } else {
    return getRunningAverageFromDb(app)
      .then(calcRunningAverage)
      .then(writeRunningAverageToDb)
  }
}
